/**
 * Pretext CLS Prevention
 * Uses @chenglou/pretext to pre-calculate text heights for product cards,
 * preventing Cumulative Layout Shift (CLS) in collection grids.
 */
import { prepare, layout } from 'https://esm.sh/@chenglou/pretext';

function computeHeight(el) {
  if (!el) return 0;
  const text = el.textContent.trim();
  if (!text) return 0;

  const style = getComputedStyle(el);
  const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
  const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
  const width = el.clientWidth;

  if (width <= 0) return 0;

  const prepared = prepare(text, font);
  const result = layout(prepared, width, lineHeight);
  return result.height;
}

async function preventCLS() {
  // Wait for fonts so Canvas measurements match actual rendering
  await document.fonts.ready;

  const cards = document.querySelectorAll('.card__content > .card__information');
  if (!cards.length) return;

  cards.forEach((card) => {
    const titleEl = card.querySelector('.card__heading');
    const taglineEl = card.querySelector('.card__tagline');
    const flavorsEl = card.querySelector('.card_available_flavors');

    let totalHeight = 0;
    totalHeight += computeHeight(titleEl);
    totalHeight += computeHeight(taglineEl);
    totalHeight += computeHeight(flavorsEl);

    // Account for margins/padding between text elements
    const childCount = [titleEl, taglineEl, flavorsEl].filter(Boolean).length;
    totalHeight += childCount * 4; // approximate gap between elements

    if (totalHeight > 0) {
      card.style.minHeight = `${Math.ceil(totalHeight)}px`;
    }
  });

  console.log(`[pretext-cls] Stabilized ${cards.length} product card(s)`);
}

preventCLS();
